export default __webpack_public_path__ + "static/media/blog-3.fbdf63ab.jpg";